import React from 'react';
import classNames from 'classnames';
import { Field, FieldProps, FormikProps } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import { IFieldProps } from '../';
import SimpleSelect from 'src/Components/Controls/SimpleSelect';
import { FeedbackMessage } from 'src/UI';

/**
 * Рендер поля выпадающего списка
 */
const SelectBoxField = (props: IFieldProps) => {
	const {
		name,
		title,
		setData,
		options,
		isRequired = false,
		disabled = false,
		placeholder,
	} = props;

	const onChangeValueHandler = (value: any, form: FormikProps<any>) => {
		form.setFieldTouched(name, true);
		form.setFieldValue(name, value);
		!!setData &&
			setData((data: any) => {
				return { ...data, [name]: value };
			});
	};

	return (
		<Field id={name} name={name}>
			{({ form, meta, field }: FieldProps) => {
				return (
					<FormGroup>
						{!!title && (
							<Label
								htmlFor={name}
								className={isRequired ? 'field_asterix' : ''}
							>
								{title}
							</Label>
						)}
						<SimpleSelect
							disabled={disabled}
							placeholder={placeholder}
							value={field.value}
							className={classNames({
								'is-invalid': meta.error && meta.touched,
							})}
							options={options.map((opt) => {
								return { id: opt.value, title: opt.display };
							})}
							setValue={(val) => {
								return onChangeValueHandler(val, form);
							}}
							onClose={() => {
								return form.setFieldTouched(name);
							}}
						/>
						{meta.error && meta.touched && (
							<FeedbackMessage message={meta.error} />
						)}
					</FormGroup>
				);
			}}
		</Field>
	);
};

export default SelectBoxField;
